import { render, staticRenderFns } from "./AssignProvidersToPlanModal.vue?vue&type=template&id=0ff5e628&scoped=true&"
import script from "./AssignProvidersToPlanModal.vue?vue&type=script&lang=js&"
export * from "./AssignProvidersToPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignProvidersToPlanModal.vue?vue&type=style&index=0&id=0ff5e628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5e628",
  null
  
)

component.options.__file = "AssignProvidersToPlanModal.vue"
export default component.exports